__turbopack_context__.v({
  "actionButton": "PdpRefresh-module__q_IZZW__actionButton",
  "actionGroup": "PdpRefresh-module__q_IZZW__actionGroup",
  "contentShell": "PdpRefresh-module__q_IZZW__contentShell",
  "linkAction": "PdpRefresh-module__q_IZZW__linkAction",
});
